(function () {
  document.querySelectorAll('[data-benefit-tabs]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-benefit-tab]');
    const panels = root.querySelectorAll('[data-benefit-panel]');
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.getAttribute('data-benefit-tab-index');
        if (index == null) return;

        tabs.forEach((t) => {
          const active = t.getAttribute('data-benefit-tab-index') === index;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.getAttribute('data-benefit-panel-index') === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  });
})();
